MOVE.MORTGAGE.RATES.PAGINATION_VIEW = (function() {
  var props,
      $pagination = $('#pagination');

  var init = function(propsRef) {
    props = propsRef;
  };

  var render = function() {
    var pages = {
      total: props.pagination.totalPages,
      current: props.pagination.page,
      left: 1,
      right: 1,
      insideWindow: 1
    };
    var paginationHtml = JST["templates/pagination/paginator"]({pages: pages});
    $pagination.html(paginationHtml);

    var totalFoundHtml = _.template(
      '<div class="total-rates-found">Found <%= total %> matching rates</div>'
    );
    var totalFound = totalFoundHtml({total: props.pagination.total});
    $pagination.prepend(totalFound);

    if (!MOVE.Helper.isPhone()) {
      var perPageHtml = JST["templates/mortgage/rate_table_rates_per_page"]({
        perPage: props.pagination.perPage
      });
      $pagination.append(perPageHtml);
    }

    if (props.pagination.totalPages < 1) {
      $pagination.find('.pagination').hide();
      $('div.rates-per-page').hide();
    }
    $pagination.show();
    bind();
  };

  var bind = function() {
    $pagination.find('span.page a').bind('click', function (e) {
      props.pagination.page = parseInt(e.target.innerHTML, 10);
      $('body').trigger('rates.displayCards');
      return false;
    });

    $pagination.find('span.next a').bind('click', function () {
      props.pagination.page++;
      $('body').trigger('rates.displayCards');
      return false;
    });

    $pagination.find('span.prev a').bind('click', function () {
      props.pagination.page--;
      $('body').trigger('rates.displayCards');
      return false;
    });

    if (!MOVE.Helper.isPhone()) {
      $('select.js-rates-per-page').on('change', handlePerPageChange);
    }
  };

  var handlePerPageChange = function (e) {
    var perPage = parseInt($(e.target).val(), 10);
    props.pagination.perPage = perPage;
    props.pagination.page = 1; // Reset to avoid page no longer being available
    $('body').trigger('rates.displayCards');
  };

  MOVE.MORTGAGE.RATES.PAGINATION_VIEW = {
    init: init,
    render: render,
    bind: bind,
    actions: {

    }
  };

  return MOVE.MORTGAGE.RATES.PAGINATION_VIEW;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/views/pagination_view.js